import { action, makeObservable, observable } from "mobx";
import BusinessDetailsSummary from "core/models/business-details-summary";
import { BaseStore } from "./base.store";

class BusinessDetailsStore extends BaseStore {
    businessDetails: BusinessDetailsSummary | null = null;

    constructor() {
        super();

        makeObservable(this, {
            businessDetails: observable,
            updateBusinessDetails: action
        });
    }

    reset() {
        super.reset();
        this.businessDetails = null;
    }

    updateBusinessDetails(value: BusinessDetailsSummary) {
        this.businessDetails = value;
        this.isPopulated = true;
    }
}

export default BusinessDetailsStore;
